<template>
  <footer>
    <div class="container">
      <div class="row mb-3">
        <div class="col-12">
          <div class="row">
            <div class="col-8">
              <img :src="getStaticPath(footerLogo)" class="logo" alt="Footer Logo" />
              <social-media-buttons :media-links="mediaLinks"></social-media-buttons>
            </div>
            <div class="hidden-md-up col-4 text-right">
              <button class="button-primary button-up" v-on:click="scrollTop"><icon name="arrow-up"></icon></button>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-8 navigation-mobile-bg">
              <footer-navigation></footer-navigation>
            </div>
            <div class="col-md-4 col-12">
              <footer-journals-family></footer-journals-family>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer-copyright></footer-copyright>
  </footer>
</template>
<script>
  import FooterCopyright from '@/components/main-layout/footer-area/copyright/FooterCopyrightComponent'
  import SocialMediaButtons from '@/components/main-layout/shared/SocialMediaButtonsComponent'
  import FooterNavigation from '@/components/main-layout/footer-area/navigation/FooterNavigationComponent'
  import FooterJournalsFamily from '@/components/main-layout/footer-area/journals-family/FooterJournalsFamilyComponent'
  import UtilityMixin from '@/components/shared/mixins/UtilityMixin'

  export default {
    components: {
      FooterCopyright,
      SocialMediaButtons,
      FooterNavigation,
      FooterJournalsFamily
    },
    name: 'footer-area',
    mixins: [ UtilityMixin ],
    data () {
      return {
        footerLogo: 'img/' + process.env.SITE + '/footer-logo.png',
        mediaLinks: {
          facebookUrl: process.env.SOCIAL_FB_URL,
          twitterUrl: process.env.SOCIAL_TW_URL,
          youTubeUrl: process.env.SOCIAL_YT_URL,
          googlePlusUrl: process.env.SOCIAL_GP_URL,
          linkedInUrl: process.env.SOCIAL_LI_URL
        }
      }
    },
    methods: {
      scrollTop () {
        document.body.scrollTop = document.documentElement.scrollTop = 0
      }
    }
  }
</script>
<style lang="scss" scoped>
  footer {
    background-color: $footer-background;
    padding-top: 20px;
    border-top: 1px solid $border-color;

    .container {
      height: 100%;

      .list-inline {
        display: inline-block;
        margin-left: 20px;
      }

    }

    .button-up{
      height: 60px;
    }
  }
  @media (max-width: $breakpoint-md) {
    .navigation-mobile-bg {
      background-color: $footer-copyright-background;
      margin: 20px 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// FooterAreaComponent.vue?1e363a62